<template>
  <div>
    <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" />
    <div
      class="modal fade"
      id="episodeListModal"
      tabindex="-1"
      aria-labelledby="episodeListModalLabel"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content AddNewChannelModal_content border-0">
          <div class="modal-header AddNewChannelModal_header">
            <h5 class="modal-title" id="episodeListModalLabel">
              <img
                src="../../assets/images/left.svg"
                class="me-2"
                width="20"
                height="20"
              />
             Episode List
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
            <div class="modal-body">
              <div class="table-responsive">
              <table class="table table-dark table-sm align-middle">
                <thead>
                <tr>
                  <th scope="col">#</th>
                  <th style="min-width: 125px" scope="col">Episode Name</th>
                  <th style="min-width: 115px" scope="col">Audiobook id</th>
                  <th style="min-width: 200px" scope="col">Episode Status</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in episodes" :key="index">
                  <th scope="row">{{index + 1}}</th>
                  <td>{{data.name}}</td>
                  <td>{{data.audiobook_id}}</td>
                  <td>
                    <div>
                      <input class="switch" type="checkbox" :id="'first-toggle-btn' + index"  v-model="data.isfree"
                             @click="updateStatus( $event, index, data, data.isfree)"/>
                      <label :for="'first-toggle-btn' + index"></label>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
              </div>
            </div>
            <div class="modal-footer">
              <button
                class="btn btn-secondary btn-sm"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
export default {
  name: "EpisodeListModal",
  components: { Loading },
  props: [
    "audioBookID"
  ],
  data() {
    return {
      //for loader
      isLoading: false,
      fullPage: true,
      loader: "bars",
      audiobook: {},
      episodes: [],
    };
  },
  async mounted() {
    await this.getData();
  },
  watch: {
    audioBookID:function (val, oldVal) {
     this.getData()
    }
  },
  methods: {
    async getData() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.get(
            this.$baseUrl + this.$api + this.$version1 + "/audiobooks/" + this.audioBookID,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
        );
        if (res.status === 200) {
          console.log(res)
          this.audiobook = res.data[0][0];
          this.episodes = res.data[4];

        } else {
          this.$vToastify.error("Could not fetch data!");
        }
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
      this.isLoading = false;
    },
    updateStatus: async function (event, index, data, isActiveStatus) {
      let isActiveValue
      if(event.target.checked === false){
        isActiveValue = 0
      }
      if (event.target.checked === true){
        isActiveValue = 1
      }

      console.log(data);
      this.$swal.fire({
        title: 'Are you sure?',
        text: "Are you sure to update this data?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const token = localStorage.getItem(this.$tokenKey);
            const res = await axios.post(
                this.$baseUrl + this.$api + this.$version2 + "/audiobooks/updateIsFree",
                {
                  isFree: isActiveValue,
                  episodeId: data.id,
                  audiobookId: data.audiobook_id
                },
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                  },
                }
            );
            this.isLoading = false;
            if (res.status === 200 || res.status === 201 ) {
              await this.getData();
            }
          } catch (error) {
            console.log(error);
            await this.getData();
            this.$swal.fire({
              icon: "error",
              text: "An error occurred!"
            });
          }
        } else {
          this.episodes[index].isfree = isActiveStatus
        }
      })
    },
  }
};
</script>


<style scoped>
/* switch button*/
@keyframes change-content {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.switch {
  position: absolute;
  clip-path: circle(0%);
  opacity: 0;
}
.switch + label {
  display: inline-block;
  margin: 20px;
  width: 68px;
  height: 30px;
  position: relative;
  border: 2px solid #F5F9F9;
  border-radius: 30px;
  cursor: pointer;
  font-size: 25px;
  text-align: center;
  background: #F5F9F9;
  /* for slider thumb */
  /* for text content */
}
.switch + label:before, .switch + label:after {
  display: block;
  position: absolute;
}
.switch + label:before {
  content: 'l';
  width: 24px;
  height: 25px;
  border-radius: 25px;
  left: 5px;
  top: 1px;
  background: #243A69;
  transition: all 0.3s ease-in-out;
  color: #ffffff;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.switch + label:after {
    display: block;
    content: 'Premium';
    left: 187%;
    top: -6px;
    transform: translateX(-50%);
    color: #607d8b;
   width: 101px;
  text-align: left;
}
.switch:checked + label:before {
  left: 35px;
  background: #4caf50;
}
.switch:checked + label:after {
    content: 'Free';
    color: #4caf50;
    animation: change-content 0.3s forwards linear;
}
</style>
